import { NOTIFICATION_TYPES } from "../getStockPageSectionFromNotificationType";
import {
  NOTIFICATION_DELIVERY_MODE,
  SIGNAL_DETAIL_TYPES
} from "./sidSignalDetailTypes";

export const NOTIFICATION_NAVIGATION_KIND = {
  STOCK_SECTION: "stock_section",
  SID_DASHBOARD: "sid_dashboard",
  TREND_DASHBOARD_SIGNALS: "trend_dashboard_signals"
};

function resolveHighsAndLowsStrategyNavigation(config = {}) {
  if (config.delivery_mode === NOTIFICATION_DELIVERY_MODE.BATCH) {
    return { kind: NOTIFICATION_NAVIGATION_KIND.SID_DASHBOARD };
  }

  const isStockDeepLink =
    config.detail_type === SIGNAL_DETAIL_TYPES.ENTRY ||
    config.detail_type === SIGNAL_DETAIL_TYPES.TP1;

  if (!isStockDeepLink) {
    return null;
  }

  const market = config.market;
  const ticker = config.ticker;

  if (!market || !ticker) {
    return null;
  }

  // Section is resolved by the platform factory via
  // getStockPageSectionFromNotificationType(notificationType).
  return {
    kind: NOTIFICATION_NAVIGATION_KIND.STOCK_SECTION,
    market,
    ticker
  };
}

function resolveSupplyDemandStrategyNavigation(config = {}) {
  const market = config.market;
  const ticker = config.ticker;

  if (!market || !ticker) {
    return null;
  }

  return {
    kind: NOTIFICATION_NAVIGATION_KIND.STOCK_SECTION,
    market,
    ticker
  };
}

export function resolveNotificationNavigation({
  notificationType,
  config = {}
} = {}) {
  if (
    notificationType === NOTIFICATION_TYPES.TRANSACTION_STRATEGY_HIGHS_AND_LOWS
  ) {
    return resolveHighsAndLowsStrategyNavigation(config);
  }

  if (
    notificationType === NOTIFICATION_TYPES.TRANSACTION_STRATEGY_SUPPLY_DEMAND
  ) {
    return resolveSupplyDemandStrategyNavigation(config);
  }

  if (
    notificationType === NOTIFICATION_TYPES.DONCHAIN_H4 ||
    notificationType === NOTIFICATION_TYPES.TRANSACTION_STRATEGY_TREND
  ) {
    const intent = {
      kind: NOTIFICATION_NAVIGATION_KIND.TREND_DASHBOARD_SIGNALS
    };

    if (config.market) {
      intent.market = config.market;
    }

    return intent;
  }

  return null;
}
